export default "__VITE_ASSET__adca9211__"